import { useEffect, useState } from 'react';
import {
  getCurrentUserType,
  IUserType,
  recognizedUser,
  updateContactProblemDataLocal,
} from '@vfit/consumer/data-access';
import { ICommonData, IPersonalDataObject } from '@vfit/shared/models';
import { trackLink } from '@vfit/shared/data-access';
import { IContactInfo } from '../../checkout.models';
import { updateContactDataLocal } from './contactCard.utils';
import { useCheckout } from '../../../iBuyFixed.context';
import { ID_FLOWS } from '../../checkout.constants';
import Contact from './components/Contact/contact';
import { usePostOtpFlow } from '../../hooks/UsePostOtpFlow/usePostOtpFlow.hook';
import ContactTagging from './contactCard.tagging';
import LoadingCard from '../LoadingCard/loadingCard';

const ContactCard = (props: ICommonData) => {
  const { handleOnChangeEnableGoNext } = props;
  const {
    owningData,
    contactInfo,
    setOwningData,
    setContactInfo,
    setCurrentStepKey,
    setIsDisabledBackButton,
    customerFlow,
  } = useCheckout();
  const { isLoading } = usePostOtpFlow(props);
  const [isValidForm, setIsValidForm] = useState(false);

  useEffect(() => {
    if (handleOnChangeEnableGoNext) {
      setIsDisabledBackButton(false);
      if (recognizedUser()) {
        setTimeout(() => {
          handleOnChangeEnableGoNext(!isLoading && (isValidForm || (recognizedUser() as boolean)));
        }, 800);
      } else {
        setTimeout(() => {
          handleOnChangeEnableGoNext(!isLoading && isValidForm);
        }, 800);
      }
    }
  }, [isValidForm, isLoading]);

  useEffect(() => {
    if (owningData.owningIndividual) updateContactDataLocal(owningData);
  }, [owningData?.owningIndividual]);

  useEffect(() => {
    setCurrentStepKey(ID_FLOWS.CONTACT_CARD);
    updateContactProblemDataLocal(contactInfo);
  }, []);

  const onChangeData = (data: IPersonalDataObject) => {
    updateContactDataLocal(data);
    setOwningData(data);
  };

  const onChangeCheck = (data: IContactInfo) => {
    let trackData = 'off';

    if (data.checkContactProblem) {
      trackData = 'on';
    }
    trackLink(`re-contact checkbox ${trackData}`);
    updateContactProblemDataLocal(data);
    setContactInfo(data);
  };

  if (
    isLoading &&
    customerFlow?.associateCustomer?.isLoading &&
    customerFlow?.associateCustomer?.isError
  ) {
    return <LoadingCard />;
  }

  return (
    <>
      {!isLoading && <ContactTagging />}
      <Contact
        data={owningData}
        checkInfo={contactInfo}
        onChangeData={onChangeData}
        onChangeCheck={onChangeCheck}
        isReadOnly={
          getCurrentUserType() === IUserType.NEXT_USER_ACTIVE ||
          getCurrentUserType() === IUserType.LOGGED_USER
        }
        setIsValidForm={(valid: boolean) => setIsValidForm(valid)}
      />
    </>
  );
};

export default ContactCard;

